<template>
  <div>
    <v-form @submit.prevent="submit">
      <v-card class="mb-4">
        <v-card-text>
          <p class="text-center"
             v-if="loading">
            <v-progress-circular size="64"
                                 indeterminate>
            </v-progress-circular>
          </p>
          <v-autocomplete v-if="templates.length"
                          v-model="form.template"
                          :items="templates"
                          item-value="id"
                          :item-text="templateNameSubject"
                          return-object
                          full-width
                          label="Which email template do you want to send?"
                          outlined
                          hide-details
                          placeholder="Select a template.">
            <template v-slot:item="{item}">
              <div class="d-block py-2">
                <div class="text-h6">
                  Name: {{ item.name }}
                </div>
                <div class="text-body-1">
                  Subject: {{ item.subject }}
                </div>
                <div v-if="item.expires_at"
                     class="text-body-1">
                  Expires: {{ item.expires_at | datetime('MMMM D, YYYY', false) }}
                </div>
              </div>
            </template>
          </v-autocomplete>
          <v-alert type="warning"
                   v-if="!loading && !templates.length">
            You don't have access to any templates. Contact your Mobile Locker administrator.
          </v-alert>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn @click.prevent="goBack"
                 :disabled="loading">
            Go back
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit"
                 :disabled="loading || !template"
                 color="primary">
            Next
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <share-template-instructions-alert :template="template">
    </share-template-instructions-alert>

    <v-card v-if="template">
      <v-toolbar color="primary"
                 dark
                 flat
                 tile>
        <v-toolbar-title>
          Preview
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <div>
          Subject: {{ template.subject }}
        </div>
        <v-divider></v-divider>
      </v-card-text>
      <v-responsive v-if="dataURI"
                    class="mx-4 embed-responsive"
                    :aspect-ratio="4/3">
        <iframe :src="dataURI">
        </iframe>
      </v-responsive>
    </v-card>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import formValidation from '../../../plugins/formValidation';
import {Form} from 'vform';
import {find} from 'lodash';
import shareTemplateService from '../../../../../ml/services/shareTemplateService';
import ShareTemplateInstructionsAlert from "./components/ShareTemplateInstructionsAlert";
import htmlService from '../../../services/htmlService';

export default {
  name: 'email-campaign-template',
  components: {ShareTemplateInstructionsAlert},
  mixins: [formValidation],
  data() {
    return {
      form: new Form({
        template: null,
      }),
      loading: false,
      templates: [],
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    ...mapGetters('emailCampaignCart', [
      'cart',
      'list',
    ]),
    dataURI() {
      if (this.template && this.template.full_html) {
        return htmlService.dataURI(this.template.full_html);
      }
      return null;
    },
    template() {
      if (this.form.template) {
        return this.form.template;
      }
      return null;
    },
    templateID() {
      if (this.$route.query.template_id) {
        return parseInt(this.$route.query.template_id);
      }
      return null;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      shareTemplateService.getTemplatesForUser({is_campaign: true})
        .then(data => {
          this.templates = data.filter(template => { // MLD-2290
            if (template.is_default) {
              return false;
            }
            return template.is_campaign;
          });

          if (this.cart.template) {
            this.form.template = find(this.templates, t => t.id === this.cart.template.id);
          } else if (this.templateID) {
            this.form.template = find(this.templates, t => t.id === this.templateID);
          }
        })
        .finally(() => {
          this.loading = false;
        })
    },
    goBack() {
      this.$store.dispatch('emailCampaignCart/prevStep');
      this.$router.replace({name: `${this.$root.routePrefix}.mailcoach.campaigns`});
    },
    submit() {
      this.$store.dispatch('emailCampaignCart/setTemplate', this.form.template);
      this.$store.dispatch('emailCampaignCart/nextStep');
      this.$router.push({name: `${this.$root.routePrefix}.mailcoach.campaign.wizard.recipients`, query: this.$route.query});
    },
    templateNameSubject(template) { // MLD-4352
      return `${template.name} ${template.subject}`;
    }
  }
}
</script>
<style lang="scss"
       scoped>
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video,
.embed-responsive .framecover, {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.framecover {
  z-index: 99999;
}
</style>
